const mergeStyles = (defaultStyle, overrideStyle) => {
  return overrideStyle
    ? Object.entries(defaultStyle).reduce((acc, [key, value]) => {
        const overrides = overrideStyle[key] || {}
        acc[key] = {
          ...value,
          ...overrides
        }
        return acc
      }, {})
    : defaultStyle
}

export default mergeStyles
